<template>
  <div class="dynamicParameters">
    <el-radio-group v-model="dynamicParameters">
      <div class="dynamicParameters-item">
        <el-radio :label="1">当前新增/修改数据的用户</el-radio>
      </div>
      <div class="dynamicParameters-item">
        <el-radio :label="2">当前新增/修改数据的用户的直属领导</el-radio>
      </div>
    </el-radio-group>
  </div>
</template>

<script lang="ts" setup>
import { computed, unref, watch, type PropType } from 'vue'

const emit = defineEmits(['update:modelValue', 'updateParameter'])
const props = defineProps({
  modelValue: {
    type: Number as PropType<Recordable>,
    default: () => {}
  }
})
const dynamicParameters = computed({
  get: () => unref(props.modelValue),
  set: newValue => {
    emit('update:modelValue', newValue)
  }
})
</script>

<style lang="scss" scoped>
.dynamicParameters {
  height: 100%;
  padding: 16px 0 0 16px;
  &-item {
    display: block;
    width: 100%;
  }
}
</style>
